import React, { useCallback, useImperativeHandle, useState } from 'react'
import SydModal from '../../../commonDesign/SydModal'
import ThingDialogForm from './form'

const ThingDialog = React.forwardRef(function ThingDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ config: null, open: false, processing: false })
  const [isEdit, setIsEdit] = useState(false)
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (config, isEdit) => {
      setDialogState({ config, open: true, processing: false })
      setIsEdit(isEdit)
    }
  }), [setDialogState, setIsEdit])

  return (
    <SydModal
      title={dialogState.config?.title ?? ''}
      open={dialogState.open}
      onClose={close}
      position='top'
      size={dialogState.config?.metadata?.dialogSize ?? 'small'}
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<ThingDialogForm config={{ asset: dialogState.config.asset, levelTypeId: dialogState.config.asset.levelTypeId, levelId: dialogState.config.asset.levelId, code: dialogState.config.code, content: dialogState.config.content, ordinal: dialogState.config.ordinal }} isEdit={isEdit} onComplete={close} onCancel={close} />) : null}
      </div>
    </SydModal>
  )
})

ThingDialog.propTypes = {
}

export default ThingDialog
